/* ZINKE — Warenkorb ohne Weiterleitung, Stand 15.09.2026

   Frueher sprang die Seite nach jedem "In den Warenkorb" auf /cart. Das riss
   den Kunden aus dem Stoebern. Jetzt wird im Hintergrund gelegt, die Seite
   bleibt stehen, das Warenkorbsymbol blinkt kurz golden auf und eine Meldung
   zeigt, wie weit es noch bis zum kostenlosen Versand ist.

   Ohne JavaScript bleibt alles wie vorher: das Formular wird normal
   abgeschickt und Shopify leitet weiter. Nichts geht verloren.

   AENDERUNG 15.09.2026 — mehrere Waehrungen und Sprachen:
   Versandgrenze, Versandpreis, Waehrung und alle Hinweistexte kommen jetzt
   aus dem JSON-Block, den snippets/zinke-versand.liquid je Land und Sprache
   ausgibt. Vorher standen 6500 Cent und 599 Cent fest im body-Tag und jeder
   Satz war deutsch — in Daenemark, Schweden und Polen war beides falsch.

   AENDERUNG 18.09.2026 (Theme 2.7) — doppelte "In den Warenkorb"-Meldung:
   Gemessen auf zinke.store: ein Klick auf "In den Warenkorb" ergab ZWEI
   Ereignisse product_added_to_cart (verschiedene event_ids) und damit je
   zweimal AddToCart bei TikTok, Meta und Google Ads. Ursache: Shopifys
   Standard-Ereignisse beobachten sowohl das submit-Ereignis eines
   /cart/add-Formulars als auch den Aufruf von /cart/add.js. Das Theme fing
   das submit ab und rief danach add.js auf — Shopify zaehlte beides.
   Gegenprobe: add.js ohne vorheriges submit ergibt genau EIN Ereignis.
   Deshalb wird jetzt schon der KLICK auf den Kaufen-Knopf abgefangen
   (Capture-Phase). Dann entsteht gar kein submit-Ereignis, und Shopify sieht
   nur noch den add.js-Aufruf. Die Enter-Taste in einem Formularfeld loest
   laut HTML-Standard ebenfalls einen Klick auf den Absende-Knopf aus und
   laeuft damit denselben Weg. Der submit-Listener bleibt als Rueckfall fuer
   Formulare ohne Knopf.

   Vier Aufgaben:
   1. Absenden aller Warenkorb-Formulare abfangen (Produktseite, Startseite,
      inklusive der Checkbox "Passend dazulegen", die zwei Artikel legt).
   2. Anzahl, Goldpuls und Meldung aktualisieren.
   3. Die Hinweise im Block "Gut kombiniert" auf den echten Warenkorbwert
      umrechnen.
   4. In der Checkbox "Passend dazulegen" live ausrechnen, ob der Zusatz den
      Versand freischaltet. Die Preise liefert der Abschnitt
      sections/produktdaten.liquid als JSON.
*/
(() => {
  'use strict';

  const PULSDAUER = 1600;

  let letzteSumme = 0;

  /* --- Versanddaten und Texte aus dem Liquid-Block ----------------------- */
  const RUECKFALL = {
    gratisAb: 0,
    versand: 0,
    waehrung: 'EUR',
    locale: 'de-DE',
    texte: {
      imKorb: '{t} liegt im Warenkorb',
      imKorbMehr: '{t} und 1 weiterer Artikel liegen im Warenkorb',
      frei: 'Versand ist kostenlos',
      nochBis: 'Noch {b} bis zum kostenlosen Versand',
      bereitsFrei: 'Versand ist bereits frei',
      damitFrei: 'Damit versandkostenfrei',
      dannNoch: 'Dann noch {b} bis versandfrei',
      addonSpart: 'Damit entfällt der Versand – {b} gespart',
      addonFrei: 'Damit ist der Versand kostenlos',
      addonNoch: 'Dann noch {b} bis zum kostenlosen Versand',
      korb: 'Warenkorb',
      fehler: 'Der Artikel konnte nicht hinzugefügt werden. Bitte erneut versuchen.'
    }
  };

  let versanddatenCache = null;

  function versanddaten() {
    if (versanddatenCache) return versanddatenCache;
    const el = document.querySelector('[data-zinke-versand]');
    if (!el) return RUECKFALL;
    try {
      const gelesen = JSON.parse(el.textContent);
      versanddatenCache = {
        gratisAb: Number(gelesen.gratisAb) || 0,
        versand: Number(gelesen.versand) || 0,
        waehrung: gelesen.waehrung || RUECKFALL.waehrung,
        locale: gelesen.locale || RUECKFALL.locale,
        texte: Object.assign({}, RUECKFALL.texte, gelesen.texte || {})
      };
      return versanddatenCache;
    } catch {
      return RUECKFALL;
    }
  }

  function text(schluessel, ersetzungen) {
    let satz = versanddaten().texte[schluessel] || '';
    if (ersetzungen) {
      Object.keys(ersetzungen).forEach(k => {
        satz = satz.split('{' + k + '}').join(ersetzungen[k]);
      });
    }
    return satz;
  }

  /* Betrag in der Waehrung des Kunden. Kronen und Zloty stehen im Shop ohne
     Nachkommastellen (259 kr), Euro mit (5,99 €) — deshalb wird die
     Nachkommastelle nur gesetzt, wenn der Betrag sie wirklich braucht. */
  function geld(betrag) {
    const daten = versanddaten();
    const wert = betrag / 100;
    const optionen = { style: 'currency', currency: daten.waehrung };
    if (Number.isInteger(wert)) {
      optionen.minimumFractionDigits = 0;
      optionen.maximumFractionDigits = 0;
    }
    try {
      return wert.toLocaleString(daten.locale, optionen);
    } catch {
      return wert.toFixed(2);
    }
  }

  function grenze() {
    const ausDaten = versanddaten().gratisAb;
    if (ausDaten > 0) return ausDaten;
    const block = document.querySelector('[data-crosssell]');
    return block ? Number(block.dataset.gratisAb) || 0 : 0;
  }

  function versandkosten() {
    return versanddaten().versand;
  }

  function produktdaten() {
    const el = document.querySelector('[data-zinke-produktdaten]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  /* --- Meldung unten ---------------------------------------------------- */
  let meldungTimer = null;

  function meldung(haupttext, zusatz) {
    const box = document.querySelector('[data-toast]');
    if (!box) return;
    box.textContent = '';

    const zeile = document.createElement('span');
    zeile.className = 'toast-text';
    zeile.textContent = haupttext;
    box.appendChild(zeile);

    if (zusatz) {
      const note = document.createElement('span');
      note.className = 'toast-note';
      note.textContent = zusatz;
      box.appendChild(note);
    }

    const link = document.createElement('a');
    link.className = 'toast-link';
    link.href = '/cart';
    link.textContent = text('korb');
    box.appendChild(link);

    box.hidden = false;
    requestAnimationFrame(() => box.classList.add('is-visible'));
    clearTimeout(meldungTimer);
    meldungTimer = setTimeout(() => {
      box.classList.remove('is-visible');
      setTimeout(() => { box.hidden = true; }, 400);
    }, 5000);
  }

  /* --- Goldpuls am Warenkorbsymbol -------------------------------------- */
  function puls() {
    document.querySelectorAll('.cart-link').forEach(link => {
      link.classList.remove('cart-pulse');
      void link.offsetWidth; // erzwingt den Neustart der Animation
      link.classList.add('cart-pulse');
      setTimeout(() => link.classList.remove('cart-pulse'), PULSDAUER);
    });
  }

  function anzahlSetzen(anzahl) {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = anzahl; });
    document.querySelectorAll('.cart-link').forEach(link => {
      link.classList.toggle('has-items', anzahl > 0);
      const label = link.getAttribute('aria-label');
      if (label) link.setAttribute('aria-label', label.replace(/\(\d+\)/, '(' + anzahl + ')'));
    });
  }

  /* --- "Gut kombiniert" auf den echten Warenkorbwert umrechnen ----------- */
  function vorschlaegeAktualisieren(summe) {
    const block = document.querySelector('[data-crosssell]');
    if (!block) return;
    const ziel = grenze() || Number(block.dataset.gratisAb) || 0;
    if (!ziel || !summe) return; // leerer Warenkorb: der Liquid-Hinweis bleibt stehen

    block.querySelectorAll('[data-preis]').forEach(karte => {
      const hinweis = karte.querySelector('[data-hinweis]');
      if (!hinweis) return;
      const preis = Number(karte.dataset.preis) || 0;
      karte.classList.remove('is-schluessel');

      if (summe >= ziel) {
        hinweis.textContent = text('bereitsFrei');
      } else if (summe + preis >= ziel) {
        hinweis.textContent = text('damitFrei');
        karte.classList.add('is-schluessel');
      } else {
        hinweis.textContent = text('dannNoch', { b: geld(ziel - summe - preis) });
      }
    });
  }

  /* --- Live-Hinweis in der Checkbox "Passend dazulegen" ------------------ */
  function addonHinweis(summe) {
    const box = document.querySelector('.product-addon');
    if (!box) return;
    const daten = produktdaten();
    if (!daten || !daten.addon) return;
    const koerper = box.querySelector('.product-addon-body');
    if (!koerper) return;

    let zeile = koerper.querySelector('[data-addon-live]');
    if (!zeile) {
      zeile = document.createElement('span');
      zeile.className = 'product-addon-live';
      zeile.setAttribute('data-addon-live', '');
      koerper.appendChild(zeile);
    }

    const gewaehlt = document.querySelector('[data-variant-id]');
    const varianten = daten.varianten || {};
    const preis = (gewaehlt && varianten[gewaehlt.value]) || daten.preis || 0;
    const ziel = grenze();
    const ohne = summe + preis;
    const mit = ohne + daten.addon.preis;

    box.classList.remove('is-schluessel');

    if (!ziel || ohne >= ziel) {
      // Versand ist ohnehin frei – dann keine Versandbehauptung aufmachen.
      zeile.textContent = '';
      return;
    }

    if (mit >= ziel) {
      const ersparnis = versandkosten();
      zeile.textContent = ersparnis
        ? text('addonSpart', { b: geld(ersparnis) })
        : text('addonFrei');
      box.classList.add('is-schluessel');
    } else {
      zeile.textContent = text('addonNoch', { b: geld(ziel - mit) });
    }
  }

  async function warenkorbLesen() {
    try {
      const antwort = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!antwort.ok) return null;
      const korb = await antwort.json();
      letzteSumme = korb.total_price || 0;
      anzahlSetzen(korb.item_count);
      vorschlaegeAktualisieren(letzteSumme);
      addonHinweis(letzteSumme);
      return korb;
    } catch {
      return null;
    }
  }

  /* --- In den Warenkorb legen -------------------------------------------- */
  function istWarenkorbFormular(form) {
    return form instanceof HTMLFormElement && (form.getAttribute('action') || '').includes('/cart/add');
  }

  let laeuft = false;

  async function hinzufuegen(form) {
    if (laeuft) return; // Doppelklick: nur ein Aufruf
    laeuft = true;

    const button = form.querySelector('[data-add-button], button[name="add"]');
    const status = form.querySelector('[data-variant-status]');
    const addon = form.querySelector('[data-addon-variant]');
    if (button) button.disabled = true;
    if (status) { status.textContent = ''; delete status.dataset.error; }

    let koerper;
    const kopfzeilen = { Accept: 'application/json' };

    if (addon && addon.checked && addon.dataset.addonVariant) {
      const haupt = form.querySelector('[data-variant-id]') || form.querySelector('[name="id"]');
      const mengeFeld = form.querySelector('[name="quantity"]');
      const menge = Number(mengeFeld && mengeFeld.value) || 1;
      if (!haupt || !haupt.value) { if (button) button.disabled = false; laeuft = false; return; }
      kopfzeilen['Content-Type'] = 'application/json';
      koerper = JSON.stringify({
        items: [
          { id: Number(haupt.value), quantity: menge },
          { id: Number(addon.dataset.addonVariant), quantity: 1 }
        ]
      });
    } else {
      // FormData nimmt auch Felder mit, die per form-Attribut zugeordnet sind –
      // etwa die Variantenauswahl der Set-Bloecke auf der Startseite.
      koerper = new FormData(form);
    }

    try {
      const antwort = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: kopfzeilen,
        body: koerper
      });
      if (!antwort.ok) throw new Error('add failed');
      const ergebnis = await antwort.json();

      const korb = await warenkorbLesen();
      puls();

      const ersterArtikel = Array.isArray(ergebnis.items) ? ergebnis.items[0] : ergebnis;
      const titel = (ersterArtikel && (ersterArtikel.product_title || ersterArtikel.title)) || '';
      const anzahlNeu = Array.isArray(ergebnis.items) ? ergebnis.items.length : 1;
      const haupttext = anzahlNeu > 1
        ? text('imKorbMehr', { t: titel })
        : text('imKorb', { t: titel });

      let zusatz = '';
      const zielwert = grenze();
      if (korb && zielwert > 0) {
        zusatz = korb.total_price >= zielwert
          ? text('frei')
          : text('nochBis', { b: geld(zielwert - korb.total_price) });
      }

      meldung(haupttext, zusatz);
      if (addon) addon.checked = false;
    } catch {
      const fehlertext = text('fehler');
      if (status) { status.textContent = fehlertext; status.dataset.error = 'true'; }
      else meldung(fehlertext, '');
    } finally {
      if (button) button.disabled = false;
      laeuft = false;
    }
  }

  /* Klick auf einen Absende-Knopf eines Warenkorb-Formulars (auch den Knopf
     der Kaufleiste, der per form-Attribut zugeordnet ist). Capture-Phase,
     damit das Abfangen vor allem anderen passiert. preventDefault auf dem
     Klick verhindert das submit-Ereignis — siehe Kopfkommentar. */
  document.addEventListener('click', event => {
    const knopf = event.target instanceof Element
      ? event.target.closest('button, input[type="submit"]')
      : null;
    if (!knopf || knopf.disabled) return;
    if (knopf.type !== 'submit') return;
    const form = knopf.form;
    if (!istWarenkorbFormular(form)) return;
    event.preventDefault();
    hinzufuegen(form);
  }, true);

  /* Rueckfall: Formular wird ohne Knopfklick abgeschickt. */
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!istWarenkorbFormular(form)) return;
    event.preventDefault();
    hinzufuegen(form);
  });

  /* Nach einem Variantenwechsel ersetzt zinke.js den Produktblock – die
     eingefuegte Hinweiszeile ist dann weg und muss neu gesetzt werden. */
  document.addEventListener('zinke:variant:change', () => addonHinweis(letzteSumme));

  /* Beim Laden einmal abgleichen. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', warenkorbLesen);
  } else {
    warenkorbLesen();
  }
  window.addEventListener('pageshow', event => { if (event.persisted) warenkorbLesen(); });
})();
